import { React, useEffect, useState } from 'react'
import { db, auth } from '../../utils/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { signInWithEmailAndPassword } from "firebase/auth";
import { Stack, Row, Col, Button } from 'react-bootstrap';


export default function Login({user, setUser, token, setToken}) {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [showError, setShowError] = useState(false)

    const handleLogin = async (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, username, password)
        .then((userCredential) => {
            // Signed in 
            async function getUser() {
                try {
                    const docRef = doc(db, "users", userCredential.user.uid)
                    const docSnap = await getDoc(docRef)
                    
                    if (docSnap.exists()) {
                        let userData = docSnap.data()
                        userData.id = userCredential.user.uid
                        delete userData.defaultPassword
                        
                        setToken(userCredential.user.accessToken)
                        setUser(userData)
                        localStorage.setItem('ukies-webinars-admin', JSON.stringify(userData))
                        localStorage.setItem('ukies-webinars-accessToken', userCredential.user.accessToken)
                    } else {
                        // Create basic user data if document doesn't exist
                        const userData = {
                            id: userCredential.user.uid,
                            email: userCredential.user.email,
                            name: userCredential.user.displayName || userCredential.user.email
                        };
                        
                        setToken(userCredential.user.accessToken)
                        setUser(userData)
                        localStorage.setItem('ukies-webinars-admin', JSON.stringify(userData))
                        localStorage.setItem('ukies-webinars-accessToken', userCredential.user.accessToken)
                    }
                } catch (error) {
                    console.error('Error fetching user document:', error);
                    // Still allow login even if user document fetch fails
                    const userData = {
                        id: userCredential.user.uid,
                        email: userCredential.user.email,
                        name: userCredential.user.displayName || userCredential.user.email
                    };
                    
                    setToken(userCredential.user.accessToken)
                    setUser(userData)
                    localStorage.setItem('ukies-webinars-admin', JSON.stringify(userData))
                    localStorage.setItem('ukies-webinars-accessToken', userCredential.user.accessToken)
                }
            }
            getUser()
        })
        .catch((error) => {
            if(error.code == 'auth/invalid-email') {
                setError('Incorrect username or password')
            } else {
                setError(error.message);
            }
            setShowError(true)
            setTimeout(() => {
                setShowError(false)
            }, 3000)
        });
    }
    return (
        <Stack>
            <Row>
                <Col style={{display:'flex',justifyContent:'center',alignItems:'center', padding:'2rem'}}>
                    <div style={{fontSize:'1.5rem', fontWeight:'bold'}}>
                        Ukie's Webinars Admin
                    </div>
                    <form onSubmit={(e) => handleLogin(e)} style={{display:'flex', flexDirection:'column' ,gap:'1rem', width:'100%', maxWidth:'405px', padding:'1rem'}}>
                        <input type='text' name='username' className='eui-input-wrapper' value={username} onChange={(e) => {setUsername(e.target.value)}} />
                        <input type='password' name='password' className='eui-input-wrapper' value={password} onChange={(e) => {setPassword(e.target.value)}} />
                        <Button type='submit'>Inloggen</Button>
                    </form>


                    <div style={{borderRadius:'0.375rem', padding:'0.5rem 1rem', background:'darkred',color:'white',textAlign:'center',transition:'ease-in-out 2s all',cursor:'pointer',opacity:showError ? 1 : 0}} onClick={() => {setShowError(false)}}>
                        {error}
                    </div>

                </Col>
            </Row>

        </Stack>
    );
}